import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const LIMITED_SELECTOR = 'cart-quantity-selector-component[data-oum-limited="true"]';
const LIMITED_BADGE_SELECTOR = '.cart-items__limited-badge';
const LIMITED_BADGE_TEXT = 'Limité à 1 exemplaire';
const NOTICE_ID = 'OumLimitedCartNotice';
const CART_ALIGNMENT_STYLE_ID = 'OumCartAlignmentStyles';
const TERMS_CHECKBOX_SELECTOR = '#PickupTermsCheckbox, #PreorderTermsCheckbox, #GeneralTermsCheckbox';
const CART_TERMS_SCOPE_SELECTOR = '.cart-drawer__summary, .cart-summary__inner, .cart-page__summary';
const CHECKOUT_BUTTON_SELECTOR = '#checkout, button[name="checkout"], input[name="checkout"], .cart__checkout-button';

const FRAIS_VARIANT_IDS = new Set([
  '54599002489161','54799797420361','54799797453129','54799797485897','54799797518665',
  '54799797551433','54799797584201','54799797616969','54799797649737','54799797682505',
  '54799797715273','54799797748041','54799797780809','54799797813577','54799797846345',
  '54799797879113','54799797911881','54799797944649','54799797977417','54799798010185',
  '54799798042953','54799798075721','54799798108489','54799798141257','54799798174025',
  '54799805841737','54799805874505','54799805907273','54799805940041','54799805972809',
  '54799806005577','54799806038345','54799806071113','54799806103881','54799806136649',
  '54799806169417','54799806202185','54799806234953','54799806267721','54799806300489',
  '54799806333257','54799806366025','54799806398793','54799806431561','54799806464329',
  '54799806497097','54799806529865','54799806562633','54799806595401'
]);

let limitedRunning = false;
let limitedTimer = null;
let fraisRunning = false;
let fraisTimer = null;

function cartRoot() { return window.Shopify?.routes?.root || '/'; }

function installCartAlignmentStyles() {
  if (document.getElementById(CART_ALIGNMENT_STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = CART_ALIGNMENT_STYLE_ID;
  style.textContent = '@media screen and (min-width:720px){.cart-items__table-row{--cart-item-price-width:10.5rem!important}.cart-items__price{width:var(--cart-item-price-width);min-width:var(--cart-item-price-width)}}';
  document.head.appendChild(style);
}

function sectionIds() {
  return [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')]
    .map((node) => node.getAttribute('data-section-id')).filter(Boolean))];
}

function updateLimitedBadgeLabels(root = document) {
  root.querySelectorAll(LIMITED_BADGE_SELECTOR).forEach((badge) => {
    if (badge.textContent.trim() !== LIMITED_BADGE_TEXT) badge.textContent = LIMITED_BADGE_TEXT;
  });
}

function limitedVariantIds() {
  return new Set([...document.querySelectorAll(LIMITED_SELECTOR)]
    .map((selector) => selector.getAttribute('data-variant-id')).filter(Boolean).map(String));
}

function showNotice(message, isError = false) {
  document.getElementById(NOTICE_ID)?.remove();
  const notice = document.createElement('div');
  notice.id = NOTICE_ID;
  notice.className = `oum-limited-cart-notice${isError ? ' oum-limited-cart-notice--error' : ''}`;
  notice.setAttribute('role', isError ? 'alert' : 'status');
  notice.textContent = message;
  document.body.appendChild(notice);
  window.setTimeout(() => notice.remove(), isError ? 6500 : 4000);
}

function resolveCartEvent(deferred, cart, source) {
  const itemCount = Number(cart.item_count) || (cart.items || []).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  deferred.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
    detail: { sections: cart.sections || {}, items: cart.items || [], itemCount, source, didError: false },
  });
}

async function fetchCart() {
  const response = await fetch(`${cartRoot()}cart.js`, {
    headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store'
  });
  if (!response.ok) throw new Error(`Lecture du panier impossible (${response.status})`);
  return response.json();
}

async function updateCart(updates, lines, action, source) {
  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(new CartLinesUpdateEvent({ action, context: 'cart', lines, promise: deferred.promise }));
  try {
    const response = await fetch(`${cartRoot()}cart/update.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin',
      body: JSON.stringify({ updates, sections: sectionIds().join(','), sections_url: window.location.pathname }),
    });
    const cart = await response.json();
    if (!response.ok || cart.errors) throw new Error(cart.description || cart.errors || 'Mise à jour du panier impossible');
    resolveCartEvent(deferred, cart, source);
    return cart;
  } catch (error) { deferred.reject(error); throw error; }
}

async function addFraisVariant(variantId) {
  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: [{ id: variantId, quantity: 1 }], promise: deferred.promise }));
  try {
    const response = await fetch(`${cartRoot()}cart/add.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds().join(','), sections_url: window.location.pathname }),
    });
    const added = await response.json();
    if (!response.ok || added.status) throw new Error(added.description || 'Ajout des frais impossible');
    const cart = await fetchCart();
    cart.sections = added.sections || {};
    resolveCartEvent(deferred, cart, 'oum-frais-gestion');
    return cart;
  } catch (error) { deferred.reject(error); throw error; }
}

async function correctLimitedQuantities() {
  if (limitedRunning) return;
  if (fraisRunning) return scheduleLimited(300);
  const ids = limitedVariantIds();
  if (!ids.size) return;
  limitedRunning = true;
  try {
    const cart = await fetchCart();
    const updates = {}; const lines = [];
    for (const item of cart.items || []) {
      if (ids.has(String(item.variant_id)) && Number(item.quantity) > 1) {
        updates[item.key] = 1; lines.push({ id: item.key, quantity: 1 });
      }
    }
    if (!lines.length) return;
    await updateCart(updates, lines, 'update', 'oum-limited-cart');
    showNotice(lines.length > 1 ? 'Les articles limités ont été ramenés à 1 exemplaire chacun.' : 'Cet article est limité à 1 exemplaire. La quantité a été corrigée.');
  } catch (error) {
    console.error('[OUM] Correction des quantités limitées :', error);
    showNotice('La quantité limitée n’a pas pu être corrigée. Actualisez le panier puis réessayez.', true);
  } finally { limitedRunning = false; scheduleFrais(250); }
}

function fraisStateFromDom() {
  const checkbox = document.querySelector('#PickupTermsCheckbox[data-frais-eligible]');
  if (!(checkbox instanceof HTMLInputElement)) return null;
  return {
    eligible: checkbox.dataset.fraisEligible === 'true',
    variantId: String(checkbox.dataset.fraisVariantId || ''),
  };
}

async function synchronizeFrais() {
  if (fraisRunning) return;
  if (limitedRunning) return scheduleFrais(300);

  fraisRunning = true;
  try {
    let cart = await fetchCart();
    let feeItems = (cart.items || []).filter((item) => FRAIS_VARIANT_IDS.has(String(item.variant_id)));
    const realItems = (cart.items || []).filter((item) => !FRAIS_VARIANT_IDS.has(String(item.variant_id)));

    // Cas prioritaire : il ne reste aucun véritable produit.
    // Les frais doivent être supprimés même si le bloc récapitulatif et sa case à cocher ont disparu du DOM.
    if (!realItems.length) {
      if (feeItems.length) {
        const updates = {}; const lines = [];
        for (const item of feeItems) {
          updates[item.key] = 0;
          lines.push({ id: item.key, quantity: 0 });
        }
        await updateCart(updates, lines, 'update', 'oum-frais-gestion-orphelins');
      }
      return;
    }

    const state = fraisStateFromDom();
    if (!state) return;

    const desiredId = state.eligible ? state.variantId : '';
    const updates = {}; const lines = [];
    let keptDesired = false;

    for (const item of feeItems) {
      const isDesired = desiredId && String(item.variant_id) === desiredId && !keptDesired;
      if (isDesired) {
        keptDesired = true;
        if (Number(item.quantity) !== 1) {
          updates[item.key] = 1;
          lines.push({ id: item.key, quantity: 1 });
        }
      } else {
        updates[item.key] = 0;
        lines.push({ id: item.key, quantity: 0 });
      }
    }

    if (lines.length) {
      cart = await updateCart(updates, lines, 'update', 'oum-frais-gestion');
      feeItems = (cart.items || []).filter((item) => FRAIS_VARIANT_IDS.has(String(item.variant_id)));
      keptDesired = feeItems.some((item) => String(item.variant_id) === desiredId && Number(item.quantity) === 1);
    }

    if (desiredId && !keptDesired) await addFraisVariant(desiredId);
  } catch (error) {
    console.error('[OUM] Synchronisation automatique des frais de gestion :', error);
  } finally {
    fraisRunning = false;
    scheduleLimited(250);
  }
}

function scheduleLimited(delay = 120) {
  window.clearTimeout(limitedTimer);
  limitedTimer = window.setTimeout(correctLimitedQuantities, delay);
}
function scheduleFrais(delay = 180) {
  window.clearTimeout(fraisTimer);
  fraisTimer = window.setTimeout(synchronizeFrais, delay);
}

function cartTermsScope(node) { return node instanceof Element ? node.closest(CART_TERMS_SCOPE_SELECTOR) : null; }
function syncTermsCta(scope) {
  if (!(scope instanceof Element)) return;
  const checkboxes = [...scope.querySelectorAll(TERMS_CHECKBOX_SELECTOR)].filter((checkbox) => checkbox instanceof HTMLInputElement);
  if (!checkboxes.length) return;
  const accepted = checkboxes.every((checkbox) => checkbox.checked);
  const relayButton = scope.querySelector('#RelayMapCta');
  if (relayButton instanceof HTMLElement) {
    relayButton.setAttribute('aria-disabled', accepted ? 'false' : 'true');
    relayButton.style.opacity = accepted ? '' : '0.45';
    relayButton.style.pointerEvents = accepted ? '' : 'none';
    relayButton.style.cursor = accepted ? '' : 'not-allowed';
  }
  scope.querySelectorAll(CHECKOUT_BUTTON_SELECTOR).forEach((button) => {
    if (!(button instanceof HTMLButtonElement || button instanceof HTMLInputElement)) return;
    button.disabled = !accepted;
    button.setAttribute('aria-disabled', accepted ? 'false' : 'true');
    button.style.opacity = accepted ? '' : '0.5';
    button.style.pointerEvents = accepted ? '' : 'none';
    button.style.cursor = accepted ? '' : 'not-allowed';
  });
  scope.querySelectorAll('.accel-buttons-guard').forEach((guard) => guard.classList.toggle('is-blocked', !accepted));
  if (accepted) scope.querySelectorAll('.terms-error').forEach((error) => {
    if (error instanceof HTMLElement) { error.hidden = true; error.setAttribute('aria-hidden', 'true'); }
  });
}
function syncAllTermsCtas() { document.querySelectorAll(CART_TERMS_SCOPE_SELECTOR).forEach(syncTermsCta); }
function onTermsStateChange(event) {
  const checkbox = event.target;
  if (!(checkbox instanceof HTMLInputElement) || !checkbox.matches(TERMS_CHECKBOX_SELECTOR)) return;
  window.requestAnimationFrame(() => syncTermsCta(cartTermsScope(checkbox)));
}

function blockLegacyFraisToggle(event) {
  const checkbox = event.target;
  if (!(checkbox instanceof HTMLInputElement) || checkbox.id !== 'PickupTermsCheckbox') return;
  event.stopImmediatePropagation();
  window.requestAnimationFrame(() => syncTermsCta(cartTermsScope(checkbox)));
  scheduleFrais(50);
}

function refreshAll() {
  updateLimitedBadgeLabels();
  syncAllTermsCtas();
  scheduleLimited();
  scheduleFrais();
}
function onCartLinesUpdate(event) {
  const promise = event?.promise;
  if (promise && typeof promise.then === 'function') {
    promise.then(() => scheduleFrais(50)).catch(() => scheduleFrais(300));
  } else {
    scheduleFrais(100);
  }
}

function init() {
  installCartAlignmentStyles();
  refreshAll();
  new MutationObserver(() => {
    updateLimitedBadgeLabels();
    syncAllTermsCtas();
    scheduleLimited();
    scheduleFrais(100);
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener(StandardEvents.cartLinesUpdate, onCartLinesUpdate);
  document.addEventListener('change', blockLegacyFraisToggle, true);
  document.addEventListener('change', onTermsStateChange);
  document.addEventListener('input', onTermsStateChange);
  document.addEventListener('shopify:section:load', refreshAll);
  window.addEventListener('pageshow', refreshAll);
}

document.addEventListener('click', (event) => {
  const relayLink = event.target instanceof Element ? event.target.closest('#RelayMapCta') : null;
  if (!relayLink) return;
  event.preventDefault();
  if (relayLink.getAttribute('aria-disabled') === 'true') return;
  window.location.assign(`${cartRoot()}pages/choisir-mon-point-relais`);
}, true);

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init, { once: true }) : init();
